import React from 'react';

/** Sidebar dashboard icon (outline grid); local SVG so we do not depend on react-icons. */
export default function NavDashboardIcon({ className, ...rest }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}>
      <rect x="3" y="3" width="7" height="7" rx="1.25" />
      <rect x="14" y="3" width="7" height="4" rx="1.25" />
      <rect x="14" y="9" width="7" height="12" rx="1.25" />
      <rect x="3" y="14" width="7" height="7" rx="1.25" />
    </svg>
  );
}
